import script from "./MontadorPistaHipismo.vue?vue&type=script&setup=true&lang=js"
export * from "./MontadorPistaHipismo.vue?vue&type=script&setup=true&lang=js"

import "./MontadorPistaHipismo.vue?vue&type=style&index=0&id=7b1df74b&scoped=true&lang=css"
import "./MontadorPistaHipismo.vue?vue&type=style&index=1&id=7b1df74b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b1df74b"]])

export default __exports__